module.exports = __webpack_public_path__ + "static/img/success.997f511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success.png
// module id = mzrL
// module chunks = 1